export default [{
    name: "Total Rooms <br/>总房数",
    actual: 0,
    last: 0,
    sort: 0,
}, {
    name: "Total Rooms Available<br/>可售房",
    actual: 0,
    last: 0,
    sort: 1,
}, {
    name: "Total Occupied<br/>占用房合计",
    actual: 0,
    last: 0,
    sort: 2,
}, {
    name: "Paid Occupancy%<br/>出租率",
    actual: 0,
    last: 0,
    sort: 3,
}, {
    name: "Average RM Rate(RMB)<br/>平均房价（人民币）",
    actual: 0,
    last: 0,
    sort: 4,
}, {
    name: "Revpar<br/>平均每间房收益",
    actual: 0,
    last: 0,
    sort: 5,
}, {
    name: "Total Room Revenue<br/>房费合计",
    actual: 0,
    last: 0,
    sort: 6,
}, {
    name: "Total No. Of Guest<br/>住店客人数",
    actual: 0,
    last: 0,
    sort: 7,
}, {
    name: "Double Occupancy%<br/>双人入住率",
    actual: 0,
    last: 0,
    sort: 8,
}]


// WEBPACK FOOTER //
// ./src/components/table/daily/Rooms/data.js